import './../style/solutions.css';
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from "react";
import { useScrollPosition } from "../hooks/useScrollPosition";

/* Hexagon icons */
import iconCFIN from "../img/solutions/Icons/IkonaCFIN_2_biala.svg";
import iconDW from "../img/solutions/Icons/IkonaDATAWAREHOUSE_2_biala.svg";
import iconEDI from "../img/solutions/Icons/IkonaEDI_1_biala.svg";
import iconHFM from "../img/solutions/Icons/IkonaHFM_1_biala.svg";
import iconBPN from "../img/solutions/Icons/Business_Partner_Notification.svg";
import iconIMD from "../img/solutions/Icons/Item_Master_Data.svg";
import iconO2C from "../img/solutions/Icons/O2C_Integration_Proces.svg";
import iconExcell from "../img/solutions/Icons/Import_From_excel-02.svg";
import iconIntegrations from "../img/solutions/Icons/R2_Integrations-02.svg";
import iconAPons from "../img/solutions/Icons/APons_Custom-02.svg";

/* Fragments */
import Hexagons from './fragments/solutions/Hexagons';

/* Articles */
import CustomerServiceNotification from './fragments/solutions/articles/CustomerServiceNotification'
import CentralFinanceReporting from './fragments/solutions/articles/CentralFinanceReporting'

/* Background */
import gradient from './../img/offer/gradient.webp'

function Solutions() {

    // internationalization
    const { t } = useTranslation();

    // scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Create hexagons
    const hexagons = [
        {
            img: iconBPN,
            text: ['Customer', 'Service', 'Notification'],
            title: 'Customer service notification',
            subTitle: 'Placeholder',
            content: CustomerServiceNotification
        },
        {
            img: iconCFIN,
            text: ['Central', 'Finance', 'Reporting'],
            title: 'Central Finance Reporting',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
        {
            img: iconAPons,
            text: ['Custom', 'AddOns'],
            title: 'Custom AddOns',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
        {
            img: iconIMD,
            text: ['Central', 'Master Data', 'Management'],
            title: 'Central Master Data Management',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
        {
            img: iconDW,
            text: ['Data', 'Warehouse'],
            title: 'Data Warehouse',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
        {
            img: iconExcell,
            text: ['Imports', 'from', 'Excel'],
            title: 'Imports from Excel',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
        {
            img: iconEDI,
            text: ['EDIs'],
            title: 'EDIs',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
        {
            img: iconO2C,
            text: ['Intercompany', 'Solution'],
            title: 'Intercompany Solution',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
        {
            img: iconHFM,
            text: ['Hyperion', 'Financial', 'Management', 'System'],
            title: 'Hyperion Financial Management System',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
        {
            img: iconIntegrations,
            text: ['HR', 'Integrations'],
            title: 'HR Integrations',
            subTitle: 'Placeholder',
            content: CentralFinanceReporting
        },
    ];


    return (
        <div className='solutions-main-section'>
            <div className='solutions-gradient-container'>
                    <div className='solutions-gradient' />
            </div>
            <div className='hexagons-outer-container'>
                <Hexagons
                    hexagonContent={hexagons}
                    pageTitle={"Nasze rozwiązania"}
                    pageSubTitle={"Oto nasze rozwiązania dla biznesu"}
                />
            </div>
            <div class="solutions-top-spacing" />
        </div>
    );
}

export default Solutions;
